import React, { useState, useEffect } from "react";
import AminiiNavbar from "../components/AminiiNavbar";
import AminiiFooter from "../components/AminiiFooter";
import "../css/AminiiDashboard.css";

function AminiiContact() {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userFirstName, setUserFirstName] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    const user = sessionStorage.getItem("user");
    if (user) {
      try {
        const parsed = JSON.parse(user);
        setIsLoggedIn(true);
        setUserFirstName(parsed.firstName || parsed.name?.split(" ")[0] || "User");
      } catch (e) {}
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="amin-dashboard">
      <AminiiNavbar isLoggedIn={isLoggedIn} userFirstName={userFirstName} cartItemCount={0} />

      <div style={{ maxWidth: "1100px", margin: "120px auto 60px auto", padding: "0 20px" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h1
            style={{
              fontFamily: "var(--font-heading)",
              fontSize: "38px",
              fontWeight: "700",
              color: "#1a1a1a",
              marginBottom: "12px",
              letterSpacing: "2px",
            }}
          >
            CONTACT US
          </h1>
          <p style={{ color: "#666", fontSize: "16px", maxWidth: "600px", margin: "0 auto" }}>
            Have a question about sizing, custom orders, or delivery? Reach out to our dedicated client care team.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
            gap: "40px",
          }}
        >
          {/* Contact Details Card */}
          <div
            style={{
              backgroundColor: "#1a1a1a",
              color: "#ffffff",
              borderRadius: "12px",
              padding: "36px 32px",
              display: "flex",
              flexDirection: "column",
              gap: "28px",
            }}
          >
            <div>
              <h2
                style={{
                  fontFamily: "var(--font-heading)",
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#d4af37",
                  marginBottom: "8px",
                  letterSpacing: "1px",
                }}
              >
                AMINII BOUTIQUE
              </h2>
              <p style={{ color: "#cccccc", fontSize: "14px", lineHeight: "1.6" }}>
                Masjid Complex, Gandhi Bazar, Shimoga, Karnataka - 577202
              </p>
            </div>

            <div style={{ borderTop: "1px solid #333", paddingTop: "20px" }}>
              <p style={{ fontSize: "12px", color: "#888", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "6px" }}>
                WHATSAPP & ASSISTANCE
              </p>
              <a
                href="https://wa.me/9606132902"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#ffffff", fontSize: "18px", fontWeight: "600", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "8px" }}
              >
                +91 9606132902
              </a>
              <p style={{ fontSize: "13px", color: "#aaa", marginTop: "4px" }}>Mon - Sat: 10:00 AM - 8:00 PM IST</p>
            </div>

            <div style={{ borderTop: "1px solid #333", paddingTop: "20px" }}>
              <p style={{ fontSize: "12px", color: "#888", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "6px" }}>
                EMAIL ENQUIRIES
              </p>
              <a href="mailto:aminiiclothings@gmail.com" style={{ color: "#ffffff", fontSize: "16px", textDecoration: "none" }}>
                aminiiclothings@gmail.com
              </a>
            </div>

            <div style={{ borderTop: "1px solid #333", paddingTop: "20px" }}>
              <p style={{ fontSize: "12px", color: "#888", textTransform: "uppercase", letterSpacing: "1px", marginBottom: "10px" }}>
                FOLLOW US
              </p>
              <div style={{ display: "flex", gap: "16px" }}>
                <a
                  href="https://www.instagram.com/aminii.clothing.in?igsh=ZmswcHU2YmF3djBs&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#d4af37", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}
                >
                  Instagram ↗
                </a>
                <a
                  href="https://www.youtube.com/@AminiiClothing"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#d4af37", textDecoration: "none", fontSize: "14px", fontWeight: "600" }}
                >
                  YouTube ↗
                </a>
              </div>
            </div>
          </div>

          {/* Form Card */}
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #eeeeee",
              borderRadius: "12px",
              padding: "36px 32px",
            }}
          >
            {submitted ? (
              <div style={{ textAlign: "center", padding: "40px 20px" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>✨</div>
                <h3 style={{ fontFamily: "var(--font-heading)", fontSize: "24px", color: "#1a1a1a", marginBottom: "10px" }}>
                  Message Received!
                </h3>
                <p style={{ color: "#666", fontSize: "15px", marginBottom: "24px" }}>
                  Thank you for reaching out. Our team will get back to you within 24 hours.
                </p>
                <button
                  onClick={() => setSubmitted(false)}
                  style={{
                    padding: "10px 24px",
                    backgroundColor: "#1a1a1a",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Send Another Message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                <h2 style={{ fontFamily: "var(--font-heading)", fontSize: "22px", color: "#1a1a1a", marginBottom: "4px" }}>
                  Send Us A Message
                </h2>

                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "6px" }}>
                    Your Name *
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="Enter full name"
                    style={{ width: "100%", padding: "12px 14px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "14px" }}
                  />
                </div>

                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "6px" }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    placeholder="name@example.com"
                    style={{ width: "100%", padding: "12px 14px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "14px" }}
                  />
                </div>

                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "6px" }}>
                    Phone / WhatsApp Number
                  </label>
                  <input
                    type="tel"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="+91 96061 32902"
                    style={{ width: "100%", padding: "12px 14px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "14px" }}
                  />
                </div>

                <div>
                  <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#333", marginBottom: "6px" }}>
                    How can we help? *
                  </label>
                  <textarea
                    required
                    rows="4"
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    placeholder="Tell us about product inquiry, size question, or delivery details..."
                    style={{ width: "100%", padding: "12px 14px", border: "1px solid #ccc", borderRadius: "6px", fontSize: "14px", resize: "vertical" }}
                  />
                </div>

                <button
                  type="submit"
                  style={{
                    padding: "14px",
                    backgroundColor: "#1a1a1a",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: "600",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    cursor: "pointer",
                    transition: "background 0.2s ease",
                    marginTop: "8px",
                  }}
                >
                  Submit Inquiry
                </button>
              </form>
            )}
          </div>
        </div>
      </div>

      <AminiiFooter />
    </div>
  );
}

export default AminiiContact;
